export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";

export const VALIDATION ={
    EMPTY : 'Required!',
    INVAL_EMAIL : 'Invalid Email',
    INVAL_CREDENTIALS : 'Invalid Credentials',
    EMAIL_REQUIRED : 'Email Rquired',
    PASSWORD_REQUIRED : 'Password Required',
    SYSTEM_ERROR: 'System Error'
}

export const TYPE = {
    SUCCESS : 'success',
    ERROR : 'error'
}

export const END_URL = {
    LOGIN : '/user/login'
}